import * as React from 'react';
import styled from 'styled-components';

import { TrackedLink } from '@origin-digital/ods-core';

import { kebabCase } from 'lodash';
import { Orange } from '../../../../consts/variantStyles';
import { ICallToAction } from '../../../../models/content.interfaces';

const AnchorLinkPrimary = styled(TrackedLink as any)`
  ${Orange.button}
  &:hover:not(:disabled),
  &:active:not(:disabled) {
    ${Orange.buttonHover}
  }
` as any;

const Container = styled.div`
  display: block;
`;

export const CallToAction = ({
  trackingCode,
  ...props
}: ICallToAction & { trackingCode: string }) => {
  return props.ctaType && props.ctaType === 'primary' ? (
    <AnchorLinkPrimary
      data-id={`${trackingCode}-${kebabCase(props.ctaText)}`}
      href={props.ctaLink}
      target={props.ctaTarget}
    >
      {props.ctaText}
    </AnchorLinkPrimary>
  ) : null;
};

export const CallToActions = ({ ctas, trackingCode }) =>
  ctas && ctas.length > 0 ? (
    <Container>
      <CallToAction {...ctas[0]} trackingCode={trackingCode} />
    </Container>
  ) : null;
